import PropTypes from 'prop-types';

const propType = {
  type: PropTypes.string,
  status: PropTypes.string,
  _id: PropTypes.string,
  date: PropTypes.number,
};

export default { propType };
